export default __webpack_public_path__ + "static/media/597.2ef5742b.png";